/**
 * Page URL key sabitleri
 * Backend UrlPattern template_key'leri ile uyumlu; HeaderMenu ve collectPageKeysFromNodes
 * gibi yerlerde tek kaynak olarak kullanılır (hardcode dağılmasın).
 */

/**
 * Product type'lar için pages/urls API'den istenecek template key'ler.
 * Backend'deki UrlPattern template_key ve Page slug ile uyumlu (örn. private-tours, group-tours).
 * Tur listeleme: private-tours ve group-tours (Page slug). Generic tour url pattern yok.
 */
export const PRODUCT_TYPE_KEYS_FOR_PAGE_URLS: readonly string[] = [
  'private-tours',
  'group-tours',
  'yacht',
  'ship_tour',
  'mice',
];

/** UrlPattern / Page template_key — Confirm Dates (book-now) */
export const PAGE_URL_KEY_RESERVATION_BOOK_NOW = 'reservation-book-now';

/** Rezervasyon akışı sayfaları için pages/urls isteğinde kullanılacak key'ler */
export const RESERVATION_FLOW_PAGE_URL_KEYS: readonly string[] = [
  PAGE_URL_KEY_RESERVATION_BOOK_NOW,
];

/**
 * Her product type için ilgili page key'lerini döndürür (type, type-cat, type-detail, type-cat-landing).
 * MainSearchBar / ProductSearchPageLayout / HomeHeaderSearchBar için collectPageKeysFromNodes'ta kullanılır.
 */
export function getProductTypePageKeys(): string[] {
  const keys: string[] = [];
  for (const pt of PRODUCT_TYPE_KEYS_FOR_PAGE_URLS) {
    keys.push(pt);
    keys.push(`${pt}-cat`);
    keys.push(`${pt}-detail`);
    keys.push(`${pt}-cat-landing`);
  }
  return keys;
}
